import React from "react";
import {
  Box,
  HStack,
  VStack,
  Skeleton,
  Divider,
  useColorModeValue,
} from "@chakra-ui/react";

export default function GroupsSkeleton() {
  const shimmerStart = useColorModeValue("gray.100", "gray.700");
  const shimmerEnd = useColorModeValue("blue.50", "gray.600");
  const skeletonProps = { startColor: shimmerStart, endColor: shimmerEnd, speed: 1.2 };
  const cardBg = useColorModeValue("white", "gray.700");

  const SkeletonTable = ({ rows }) => (
    <Box bg={cardBg} boxShadow="md" rounded="lg" pt={2} px={5} pb={5} mx="auto" w="80%" maxW="800px">
      {/* Header row */}
      <HStack spacing={4} py={3} borderBottomWidth="1px">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} height="12px" width={i === 4 ? "100px" : "80px"} {...skeletonProps} />
        ))}
      </HStack>
      {/* Data rows */}
      {Array.from({ length: rows }).map((_, row) => (
        <HStack key={row} spacing={4} py={3} borderBottomWidth="1px">
          <Skeleton height="14px" width="100px" {...skeletonProps} />
          <Skeleton height="20px" width="50px" borderRadius="full" {...skeletonProps} />
          <Skeleton height="14px" width="80px" {...skeletonProps} />
          <Skeleton height="14px" width="90px" {...skeletonProps} />
          <HStack spacing={2}>
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} height="24px" width="24px" borderRadius="md" {...skeletonProps} />
            ))}
          </HStack>
        </HStack>
      ))}
    </Box>
  );

  return (
    <VStack spacing={6} align="stretch" w="full">
      {/* My Groups heading + Create button */}
      <HStack justifyContent="space-between">
        <Skeleton height="28px" width="140px" borderRadius="md" {...skeletonProps} />
        <Skeleton height="36px" width="140px" borderRadius="md" {...skeletonProps} />
      </HStack>

      {/* Groups table */}
      <SkeletonTable rows={3} />

      <Divider />

      {/* My Invites heading */}
      <Skeleton height="28px" width="130px" borderRadius="md" {...skeletonProps} />

      {/* Invites table */}
      <SkeletonTable rows={2} />
    </VStack>
  );
}
